export default __webpack_public_path__ + "static/PAPC-608-3c2da4d3afa2f9a8c49c38e2734d0fd3.jpg";